import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the ValidateInputPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'validateInput',
})
export class ValidateInputPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, onlyLength: boolean = false) {
    // value = value || '';
    // let newValue = '';
    // if(!onlyLength){
    //   newValue = value.replace([A-F0-9]/g,'').substring(0, 30);
    // } else {
    //   newValue = value.substring(0, 30);
    // }
    // console.log('[PIPE]', value, newValue);
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-input/validate-input.ts